// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.boder-tabla td{
 border: 2px solid #7d95a7;
}
.topright { 
    position: absolute; 
    top: 5px; 
    right: 5px; 
    text-align: center; 
    vertical-align: center
}

@keyframes rotate {from {transform: rotate(0deg);}
    to {transform: rotate(360deg);}}

.preload-button{
    animation: 1s rotate linear infinite;
    transform-origin: 50% 50%;
}

strong{
    font-weight: normal !important;
}

.bg-text
{
    color:#E6E6E6;
    font-size:22px;    
    text-align: center;    
    transform: rotate(350deg)
}`, "",{"version":3,"sources":["webpack://./src/app/pages/welcome/welcome.component.css"],"names":[],"mappings":"AAAA;CACC,yBAAyB;AAC1B;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,kBAAkB;IAClB;AACJ;;AAEA,mBAAmB,MAAM,uBAAuB,CAAC;IAC7C,IAAI,yBAAyB,CAAC,CAAC;;AAInC;IAEI,oCAAoC;IAEpC,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;IAEI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB;AACJ","sourcesContent":[".boder-tabla td{\r\n border: 2px solid #7d95a7;\r\n}\r\n.topright { \r\n    position: absolute; \r\n    top: 5px; \r\n    right: 5px; \r\n    text-align: center; \r\n    vertical-align: center\r\n}\r\n\r\n@keyframes rotate {from {transform: rotate(0deg);}\r\n    to {transform: rotate(360deg);}}\r\n@-webkit-keyframes rotate {from {-webkit-transform: rotate(0deg);}\r\n  to {-webkit-transform: rotate(360deg);}}\r\n\r\n.preload-button{\r\n    -webkit-animation: 1s rotate linear infinite;\r\n    animation: 1s rotate linear infinite;\r\n    -webkit-transform-origin: 50% 50%;\r\n    transform-origin: 50% 50%;\r\n}\r\n\r\nstrong{\r\n    font-weight: normal !important;\r\n}\r\n\r\n.bg-text\r\n{\r\n    color:#E6E6E6;\r\n    font-size:22px;    \r\n    text-align: center;    \r\n    transform: rotate(350deg)\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
